import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { CRM_HERO_IMAGE } from "@/lib/brand";

/** Gedeelde schil voor inloggen, registreren en wachtwoordpagina's: merkpaneel + formulier. */
export const AuthShell = ({ title, subtitle, children, wide = false, testId }) => {
  const { t } = useTranslation();
  const punten = ["one", "two", "three"].map((k) => t(`landing.trust.${k}.title`));
  return (
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-10 sm:px-6 lg:grid-cols-12 lg:gap-14 lg:px-8 lg:py-16" data-testid={testId}>
      <motion.aside
        initial={{ opacity: 0, x: -16 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        className={`relative hidden overflow-hidden rounded-3xl lg:block ${wide ? "lg:col-span-4" : "lg:col-span-6"}`}
      >
        <img src={CRM_HERO_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/20" aria-hidden="true" />
        <div className="relative flex h-full min-h-[560px] flex-col justify-end p-10 text-ink-foreground">
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-ink-foreground/60">{t("landing.eyebrow")}</p>
          <p className="mt-4 font-display text-3xl font-bold leading-tight tracking-tight">{t("landing.title")}</p>
          <ul className="mt-6 space-y-2.5">
            {punten.map((p) => (
              <li key={p} className="flex items-center gap-2.5 text-sm text-ink-foreground/80">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-ink-foreground/15"><Check className="h-3 w-3" aria-hidden="true" /></span>
                {p}
              </li>
            ))}
          </ul>
        </div>
      </motion.aside>
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.08 }}
        className={`mx-auto w-full ${wide ? "lg:col-span-8 max-w-2xl" : "lg:col-span-6 max-w-md"}`}
      >
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">{subtitle}</p>}
        <Card className="mt-8 rounded-2xl p-6 shadow-[0_24px_60px_-30px_hsl(30_20%_20%/0.35)] sm:p-8">{children}</Card>
      </motion.div>
    </div>
  );
};
